//#region node_modules/web-vitals/dist/web-vitals.attribution.js
var e = class {
	t;
	o = 0;
	i = [];
	l(e) {
		if (e.hadRecentInput) return;
		let t = this.i[0], n = this.i.at(-1);
		this.o && t && n && e.startTime - n.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (this.o += e.value, this.i.push(e)) : (this.o = e.value, this.i = [e]), this.t?.(e);
	}
}, t = () => {
	let e = performance.getEntriesByType("navigation")[0];
	if (e && e.responseStart > 0 && e.responseStart < performance.now()) return e;
}, n = (e) => {
	if (document.readyState === "loading") return "loading";
	let n = t();
	if (n) {
		if (e < n.domInteractive) return "loading";
		if (n.domContentLoadedEventStart === 0 || e < n.domContentLoadedEventStart) return "dom-interactive";
		if (n.domComplete === 0 || e < n.domComplete) return "dom-content-loaded";
	}
	return "complete";
}, r = (e) => {
	let t = e.nodeName;
	return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, i = (e) => {
	let t = "";
	try {
		for (; e?.nodeType !== 9;) {
			let n = e, i = n.id ? "#" + n.id : [r(n), ...Array.from(n.classList ?? []).sort()].join(".");
			if (t.length + i.length > 99) return t || i;
			if (t = t ? i + ">" + t : i, n.id) break;
			e = n.parentNode;
		}
	} catch {}
	return t;
}, a = /* @__PURE__ */ new WeakMap();
function o(e, t) {
	let n = a.get(t);
	return n || (n = /* @__PURE__ */ new WeakMap(), a.set(t, n)), n.get(e) || n.set(e, new t()), n.get(e);
}
var s = -1, c = () => s, l = (e) => {
	addEventListener("pageshow", (t) => {
		t.persisted && (s = t.timeStamp, e(t));
	}, !0);
}, u = (e, t, n, r) => {
	let i, a;
	return (o) => {
		t.value >= 0 && (o || r) && (a = t.value - (i ?? 0), (a || i === void 0) && (i = t.value, t.delta = a, t.rating = ((e, t) => e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good")(t.value, n), e(t)));
	};
}, d = (e) => {
	requestAnimationFrame(() => requestAnimationFrame(() => e()));
}, f = () => t()?.activationStart ?? 0, p = -1, m = /* @__PURE__ */ new Set(), h = () => document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0, g = (e) => {
	if (document.visibilityState === "hidden") {
		if (e.type === "visibilitychange") for (let e of m) e();
		isFinite(p) || (p = e.type === "visibilitychange" ? e.timeStamp : 0, removeEventListener("prerenderingchange", g, !0));
	}
}, _ = (e = !1) => {
	if (e && (p = 1 / 0), p < 0) {
		let e = f();
		p = (document.prerendering ? void 0 : globalThis.performance.getEntriesByType("visibility-state").find((t) => t.name === "hidden" && t.startTime >= e)?.startTime) ?? h(), addEventListener("visibilitychange", g, !0), addEventListener("prerenderingchange", g, !0), l(() => {
			setTimeout(() => {
				p = h();
			});
		});
	}
	return {
		get firstHiddenTime() {
			return p;
		},
		onHidden(e) {
			m.add(e);
		}
	};
}, v = (e, n = -1, r, i = 0, a, o, s) => {
	let l = t(), u = l?.navigationId || 0, d = "navigate";
	return r ? d = r : c() >= 0 ? d = "back-forward-cache" : l && (document.prerendering || f() > 0 ? d = "prerender" : document.wasDiscarded ? d = "restore" : l.type && (d = l.type.replace(/_/g, "-"))), {
		name: e,
		value: n,
		rating: "good",
		delta: 0,
		entries: [],
		id: `v6-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 0xe8d4a51000}`,
		navigationType: d,
		navigationId: i || u,
		navigationInteractionId: a,
		navigationURL: o || l?.name,
		navigationStartTime: s || 0
	};
}, y = (e, t, n = {}) => {
	try {
		let r = e.filter((e) => PerformanceObserver.supportedEntryTypes.includes(e));
		if (r.length > 0) {
			let e = new PerformanceObserver((e) => {
				queueMicrotask(() => {
					let n = e.getEntries();
					r.length > 1 && n.sort((e, t) => e.startTime + e.duration - (t.startTime + t.duration)), t(n);
				});
			});
			for (let t of r) e.observe({
				type: t,
				buffered: !0,
				...n
			});
			return e;
		}
	} catch {}
}, b = (e) => globalThis.PerformanceObserver?.supportedEntryTypes?.includes("soft-navigation") && typeof globalThis.PerformanceSoftNavigation?.prototype?.getLargestInteractionContentfulPaint == "function" && e && e.reportSoftNavs, x = (e, t) => {
	if (e.set(t.navigationId, t), e.size > 2) {
		let t = e.keys().next().value;
		t !== void 0 && e.delete(t);
	}
}, S = (e) => {
	let t = !1;
	return () => {
		t ||= (e(), !0);
	};
}, C = class {
	u;
}, w = (e) => {
	document.prerendering ? addEventListener("prerenderingchange", e, !0) : e();
}, T = [1800, 3e3], E = (e, t = {}) => {
	let n = b(t);
	w(() => {
		let r = o(t, C), i = _(), a, s = v("FCP"), p = y(["paint"], (e) => {
			for (let t of e) t.name === "first-contentful-paint" && (p.disconnect(), t.startTime < i.firstHiddenTime && (s.value = Math.max(t.startTime - f(), 0), s.entries.push(t), s.navigationId = t.navigationId || s.navigationId, a(!0)));
		});
		p && (a = u(e, s, T, t.reportAllChanges), l((n) => {
			s = v("FCP", -1, "back-forward-cache", s.navigationId, s.navigationInteractionId, s.navigationURL, c()), a = u(e, s, T, t.reportAllChanges), d(() => {
				s.value = performance.now() - n.timeStamp, a(!0);
			});
		})), n && y(["soft-navigation"], (n) => {
			n.forEach((n) => {
				r.u && n.navigationId && x(r.u, n), s = v("FCP", Math.max((n.presentationTime || n.paintTime || 0) - n.startTime, 0), "soft-navigation", n.navigationId, n.interactionId, n.name, n.startTime), a = u(e, s, T, t.reportAllChanges), a(!0);
			});
		}, t);
	});
}, D = [.1, .25], O = (e) => e.find((e) => e.node?.nodeType === 1) || e[0], k = (t, r = {}) => {
	let a = o(r = Object.assign({}, r), e), s = /* @__PURE__ */ new WeakMap();
	a.t = (e) => {
		if (e?.sources?.length) {
			let t = O(e.sources), n = t?.node;
			if (n) {
				let e = r.generateTarget?.(n) ?? i(n);
				s.set(t, e);
			}
		}
	}, ((t, n = {}) => {
		let r = _();
		E(S(() => {
			let i, a = v("CLS", 0), s = o(n, e), f = (e, r, o, c, l) => {
				a = v("CLS", 0, e, r, o, c, l), s.o = 0, i = u(t, a, D, n.reportAllChanges);
			}, p = (e = !1) => {
				s.o > a.value && (a.value = s.o, a.entries = s.i), i(e);
			}, m = (e) => {
				p(!0), f("soft-navigation", e.navigationId, e.interactionId, e.name, e.startTime);
			}, h = (e) => {
				for (let t of e) t.entryType === "soft-navigation" ? m(t) : s.l(t);
				p();
			}, g = ["layout-shift"];
			b(n) && g.push("soft-navigation");
			let _ = y(g, h);
			_ && (i = u(t, a, D, n.reportAllChanges), r.onHidden(() => {
				h(_.takeRecords()), i(!0);
			}), l(() => {
				f("back-forward-cache", a.navigationId, a.navigationInteractionId, a.navigationURL, c()), d(i);
			}), setTimeout(i));
		}));
	})((e) => {
		t(((e) => {
			let t = {};
			if (e.entries.length) {
				let r = e.entries.reduce((e, t) => e.value > t.value ? e : t);
				if (r?.sources?.length) {
					let e = O(r.sources);
					e && (t = {
						largestShiftTarget: s.get(e),
						largestShiftTime: r.startTime,
						largestShiftValue: r.value,
						largestShiftSource: e,
						largestShiftEntry: r,
						loadState: n(r.startTime)
					});
				}
			}
			return Object.assign(e, { attribution: t });
		})(e));
	}, r);
}, A = (e, r = {}) => {
	let i = o(r = Object.assign({}, r), C);
	b(r) && (i.u = /* @__PURE__ */ new Map()), E((r) => {
		e(((e) => {
			let r = {
				timeToFirstByte: 0,
				firstByteToFCP: e.value,
				loadState: n(c())
			};
			if (e.navigationType !== "soft-navigation") {
				if (e.entries.length) {
					let i = t(), a = e.entries.at(-1);
					if (i) {
						let t = i.responseStart, o = i.activationStart || 0, s = Math.max(0, t - o);
						r = {
							timeToFirstByte: s,
							firstByteToFCP: e.value - s,
							loadState: n(e.entries[0].startTime),
							navigationEntry: i,
							fcpEntry: a
						};
					}
				}
			} else {
				let t = i.u?.get(e.navigationId);
				t && (r = {
					timeToFirstByte: 0,
					firstByteToFCP: e.value,
					loadState: "complete",
					navigationEntry: t
				});
			}
			return Object.assign(e, { attribution: r });
		})(r));
	}, r);
}, j = 0, M = 1 / 0, N = 0, P = (e) => {
	for (let t of e) t.interactionId && (M = Math.min(M, t.interactionId), N = Math.max(N, t.interactionId), j = N ? (N - M) / 7 + 1 : 0);
}, F, I = () => F ? j : performance.interactionCount ?? 0, L = () => {
	"interactionCount" in performance || F || (F = y(["event"], P, { durationThreshold: 0 }));
}, R = class {
	h = 0;
	v = [];
	p = /* @__PURE__ */ new Map();
	m;
	M;
	T() {
		return I() - this.h;
	}
	D() {
		this.h = I(), this.v.length = 0, this.p.clear();
	}
	S(e) {
		let t = this.T(), n = Math.min(this.v.length - 1, Math.floor(t / 50));
		return !t || n !== -1 || e !== "soft-navigation" && e !== "back-forward-cache" ? this.v[n] : {
			k: 8,
			id: -1,
			entries: []
		};
	}
	l(e) {
		if (this.m?.(e), !e.interactionId) return;
		let t = this.v.at(-1), n = this.p.get(e.interactionId);
		if (n || this.v.length < 10 || e.duration > t.k) {
			if (n ? e.duration > n.k ? (n.entries = [e], n.k = e.duration) : e.duration === n.k && e.startTime === n.entries[0].startTime && n.entries.push(e) : (n = {
				id: e.interactionId,
				entries: [e],
				k: e.duration
			}, this.p.set(n.id, n), this.v.push(n)), this.v.sort((e, t) => t.k - e.k), this.v.length > 10) {
				let e = this.v.splice(10);
				for (let t of e) this.p.delete(t.id);
			}
			this.M?.(n);
		}
	}
}, z = (e) => {
	let t = "requestIdleCallback" in globalThis ? 1e3 : 0, n = globalThis.requestIdleCallback || setTimeout, r = globalThis.cancelIdleCallback || clearTimeout;
	if (document.visibilityState === "hidden") e();
	else {
		let i = S(e), a = -1, o = () => {
			r(a), i();
		};
		addEventListener("visibilitychange", o, {
			once: !0,
			capture: !0
		}), a = n(() => {
			removeEventListener("visibilitychange", o, { capture: !0 }), i();
		}, { timeout: t });
	}
}, B = [200, 500], V = (e, t = {}) => {
	let r = o(t = Object.assign({}, t), R), a = [], s = [], d = 0, f = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), m = !1, h = () => {
		m || (m = !0, z(g));
	}, g = () => {
		let e = new Set(r.v.map((e) => f.get(e.entries[0]))), t = s.length - 10;
		s = s.filter((n, r) => r >= t || e.has(n));
		let n = /* @__PURE__ */ new Set();
		for (let e of s) {
			let t = x(e.startTime, e.processingEnd);
			for (let e of t) n.add(e);
		}
		let i = a.length - 10;
		a = a.filter((e, t) => n.has(e) || t >= i && e.startTime > d), m = !1;
	};
	r.m = (e) => {
		let n = e.startTime + e.duration, r;
		d = Math.max(d, e.processingEnd);
		for (let i = s.length - 1; i >= 0; i--) {
			let a = s[i];
			if (Math.abs(n - a.renderTime) <= 8) {
				r = a, r.startTime = Math.min(e.startTime, r.startTime), r.processingStart = Math.min(e.processingStart, r.processingStart), r.processingEnd = Math.max(e.processingEnd, r.processingEnd), t.includeProcessedEventEntries && r.entries.push(e);
				break;
			}
		}
		r || (r = {
			startTime: e.startTime,
			processingStart: e.processingStart,
			processingEnd: e.processingEnd,
			renderTime: n,
			entries: t.includeProcessedEventEntries ? [e] : []
		}, s.push(r)), e.interactionId && f.set(e, r), h();
	}, r.M = (e) => {
		if (!p.get(e)) {
			let n = e.entries.find((e) => e.target)?.target;
			if (n) {
				let r = t.generateTarget?.(n) ?? i(n);
				p.set(e, r);
			} else {
				let t = e.entries.find((e) => e.targetSelector)?.targetSelector;
				t && p.set(e, t);
			}
		}
	};
	let x = (e, t) => {
		let n = [];
		for (let r of a) if (!(r.startTime + r.duration < e)) {
			if (r.startTime > t) break;
			n.push(r);
		}
		return n;
	}, S = (e) => {
		if (e.entries.length === 0) {
			let t = e.navigationStartTime || 0, r = {
				processedEventEntries: [],
				longAnimationFrameEntries: [],
				inputDelay: 0,
				processingDuration: 0,
				presentationDelay: e.value,
				loadState: n(t)
			};
			return Object.assign(e, { attribution: r });
		}
		let t = e.entries[0], i = f.get(t), a = Math.max(i.processingStart, t.startTime), o = Math.max(t.startTime + t.duration, a), s = Math.min(i.processingEnd, o), c = i.entries.sort((e, t) => e.processingStart - t.processingStart), l = x(t.startTime, s), u = r.p.get(t.interactionId), d = {
			interactionTarget: p.get(u),
			interactionType: t.name.startsWith("key") ? "keyboard" : "pointer",
			interactionTime: t.startTime,
			nextPaintTime: o,
			processedEventEntries: c,
			longAnimationFrameEntries: l,
			inputDelay: a - t.startTime,
			processingDuration: s - a,
			presentationDelay: o - s,
			loadState: n(t.startTime),
			longestScript: void 0,
			totalScriptDuration: void 0,
			totalStyleAndLayoutDuration: void 0,
			totalPaintDuration: void 0,
			totalUnattributedDuration: void 0
		};
		return ((e) => {
			let t = e.interactionTime, n = e.nextPaintTime;
			if (!e.longAnimationFrameEntries?.length || !t || !n) return;
			let r = e.inputDelay, i = e.processingDuration, a, o, s = 0, c = 0, l = 0, u = 0;
			for (let n of e.longAnimationFrameEntries) {
				c = c + n.startTime + n.duration - n.styleAndLayoutStart;
				for (let e of n.scripts) {
					let n = e.startTime + e.duration;
					if (n < t) continue;
					let l = n - Math.max(t, e.startTime), d = e.duration ? l / e.duration * e.forcedStyleAndLayoutDuration : 0;
					s += l - d, c += d, l > u && (o = e.startTime < t + r ? "input-delay" : e.startTime >= t + r + i ? "presentation-delay" : "processing-duration", a = e, u = l);
				}
			}
			let d = e.longAnimationFrameEntries.at(-1), f = d ? d.startTime + d.duration : 0;
			f >= t + r + i && (l = n - f), a && o && (e.longestScript = {
				entry: a,
				subpart: o,
				intersectingDuration: u
			}), e.totalScriptDuration = s, e.totalStyleAndLayoutDuration = c, e.totalPaintDuration = l, e.totalUnattributedDuration = n - t - s - c - l;
		})(d), Object.assign(e, { attribution: d });
	};
	y(["long-animation-frame"], (e) => {
		a = a.concat(e), h();
	}, t), ((e, t = {}) => {
		if (!globalThis.PerformanceEventTiming || !("interactionId" in PerformanceEventTiming.prototype)) return;
		let n = _();
		w(() => {
			L();
			let r, i = v("INP"), a = o(t, R), s = (n, o, s, c, l) => {
				a.D(), i = v("INP", -1, n, o, s, c, l), r = u(e, i, B, t.reportAllChanges);
			}, d = () => {
				let e = a.S(i.navigationType);
				e && e.k !== i.value && (i.value = e.k, i.entries = e.entries, r());
			}, f = (e) => {
				d(), r(!0), s("soft-navigation", e.navigationId, e.interactionId, e.name, e.startTime);
			}, p = (e, t = !1) => {
				z(() => {
					for (let t of e) t.entryType === "soft-navigation" ? f(t) : a.l(t);
					d(), t && r(!0);
				});
			}, m = ["event", "first-input"];
			b(t) && m.push("soft-navigation");
			let h = y(m, p, {
				...t,
				durationThreshold: t.durationThreshold ?? 40
			});
			r = u(e, i, B, t.reportAllChanges), h && (n.onHidden(() => {
				p(h.takeRecords(), !0);
			}), l(() => {
				s("back-forward-cache", i.navigationId, i.navigationInteractionId, i.navigationURL, c());
			}));
		});
	})((t) => {
		e(S(t));
	}, t);
}, H = class {
	m;
	u;
	l(e) {
		this.m?.(e);
	}
}, U = [2500, 4e3], W = 50, G = [];
y(["resource"], (e) => {
	for (let t of e) G.push(t), G.length > W && G.shift();
});
var K = (e, n = {}) => {
	(n = Object.assign({}, n)).resourceBufferSize != null && (W = n.resourceBufferSize);
	let r = o(n, H), a = /* @__PURE__ */ new WeakMap();
	b(n) && (r.u = /* @__PURE__ */ new Map()), r.m = (e) => {
		let t = e.element;
		if (t) {
			let r = n.generateTarget?.(t) ?? i(t);
			a.set(e, r);
		} else e.id && a.set(e, `#${e.id}`);
	}, ((e, t = {}) => {
		let n = !1, r = b(t);
		w(() => {
			let i, a = _(), s = v("LCP"), p = o(t, H), m = (r, o, c, l, d) => {
				s = v("LCP", -1, r, o, c, l, d), i = u(e, s, U, t.reportAllChanges), n = !1, r === "soft-navigation" && (a = _(!0));
			}, h = (e) => {
				p.u && e.navigationId && x(p.u, e), n || i(!0), m("soft-navigation", e.navigationId, e.interactionId, e.name, e.startTime);
				let t = e.getLargestInteractionContentfulPaint?.();
				t && g([t]);
			}, g = (e) => {
				t.reportAllChanges || r || (e = e.slice(-1));
				for (let t of e) {
					if (!t) continue;
					if (t.entryType === "soft-navigation") {
						h(t);
						continue;
					}
					let e = 0, n = [], r = t.startTime;
					if (t.entryType === "largest-contentful-paint") e = Math.max(t.startTime - f(), 0), p.l(t), n = [t];
					else if (t.entryType === "interaction-contentful-paint") {
						let i = t;
						if (!s.navigationId || "interactionId" in i && i.interactionId != s.navigationInteractionId) continue;
						r = i.largestContentfulPaint?.renderTime || 0, e = Math.max(r - t.startTime, 0), i.largestContentfulPaint && (p.l(i.largestContentfulPaint), n = [i.largestContentfulPaint]);
					}
					r < a.firstHiddenTime && (s.value = e, s.entries = n, i());
				}
			}, b = ["largest-contentful-paint"];
			r && b.push("interaction-contentful-paint", "soft-navigation");
			let S = y(b, g);
			if (S) {
				i = u(e, s, U, t.reportAllChanges);
				let a = [
					"keydown",
					"click",
					"visibilitychange"
				], o = (e) => {
					if (e.isTrusted && !n) {
						let e = s.id;
						z(() => {
							if (!n) {
								if (!r) {
									S.disconnect();
									for (let e of a) removeEventListener(e, o, { capture: !0 });
								}
								e === s.id && (n = !0, i(!0));
							}
						});
					}
				};
				for (let e of a) addEventListener(e, o, { capture: !0 });
				l((r) => {
					m("back-forward-cache", s.navigationId, s.navigationInteractionId, s.navigationURL, c()), i = u(e, s, U, t.reportAllChanges), d(() => {
						s.value = performance.now() - r.timeStamp, n = !0, i(!0);
					});
				});
			}
		});
	})((n) => {
		e(((e) => {
			let n = {
				timeToFirstByte: 0,
				resourceLoadDelay: 0,
				resourceLoadDuration: 0,
				elementRenderDelay: e.value
			};
			if (e.entries.length) {
				let i = e.entries.at(-1), o = (e) => e.name === i.url && (e.requestStart || e.startTime) <= i.startTime, s = i.url && (G.findLast(o) || performance.getEntriesByType("resource").findLast(o)), c;
				n.target = a.get(i), n.lcpEntry = i, i.url && (n.url = i.url), s && (n.lcpResourceEntry = s);
				let l = 0, u = 0;
				if (e.navigationType === "soft-navigation" ? (l = e.navigationStartTime || 0, c = r.u?.get(e.navigationId)) : (c = t(), l = c?.activationStart ?? 0, u = c?.responseStart ?? 0), c) {
					let t = Math.max(0, u - l), r = Math.max(t, s ? (s.requestStart || s.startTime) - l : 0), i = Math.min(e.value, Math.max(r, s ? s.responseEnd - l : 0));
					n = {
						...n,
						timeToFirstByte: t,
						resourceLoadDelay: r - t,
						resourceLoadDuration: i - r,
						elementRenderDelay: e.value - i,
						navigationEntry: c
					};
				}
			}
			return Object.assign(e, { attribution: n });
		})(n));
	}, n);
}, q = [800, 1800], J = (e) => {
	document.prerendering ? w(() => J(e)) : document.readyState === "complete" ? setTimeout(e) : addEventListener("load", () => J(e), !0);
}, Y = (e, n = {}) => {
	((e, n = {}) => {
		let r = b(n), i = v("TTFB"), a = u(e, i, q, n.reportAllChanges);
		J(() => {
			let o = t();
			if (o) {
				let t = o.responseStart;
				i.value = Math.max(t - f(), 0), i.entries = [o], a(!0), l(() => {
					i = v("TTFB", 0, "back-forward-cache", i.navigationId, i.navigationInteractionId, i.navigationURL, c()), a = u(e, i, q, n.reportAllChanges), a(!0);
				}), r && y(["soft-navigation"], (t) => {
					t.forEach((t) => {
						t.navigationId && (i = v("TTFB", 0, "soft-navigation", t.navigationId, t.interactionId, t.name, t.startTime), i.entries = [t], a = u(e, i, q, n.reportAllChanges), a(!0));
					});
				}, n);
			}
		});
	})((t) => {
		e(((e) => {
			let t = e.entries[0], n = {
				waitingDuration: 0,
				cacheDuration: 0,
				dnsDuration: 0,
				connectionDuration: 0,
				requestDuration: 0,
				navigationEntry: t
			};
			if (e.entries.length && t instanceof PerformanceNavigationTiming) {
				let r = t.activationStart || 0, i = Math.max((t.workerStart || t.fetchStart || 0) - r, 0), a = Math.max(t.domainLookupStart - r, 0), o = Math.max(t.connectStart - r, 0), s = Math.max(t.connectEnd - r, 0);
				n = {
					waitingDuration: i,
					cacheDuration: a - i,
					dnsDuration: o - a,
					connectionDuration: s - o,
					requestDuration: e.value - s,
					navigationEntry: t
				};
			}
			return Object.assign(e, { attribution: n });
		})(t));
	}, n);
}, { Shopify: X } = window, Z = (e) => e ? e.slice(0, 100) : void 0, Q = (e) => {
	switch (e.name) {
		case "LCP": return {
			debug_target: Z(e.attribution.target),
			lcp_resource_load_delay: Math.round(e.attribution.resourceLoadDelay),
			lcp_resource_load_duration: Math.round(e.attribution.resourceLoadDuration),
			lcp_render_delay: Math.round(e.attribution.elementRenderDelay)
		};
		case "INP": return {
			debug_target: Z(e.attribution.interactionTarget),
			inp_input_delay: Math.round(e.attribution.inputDelay),
			inp_processing_duration: Math.round(e.attribution.processingDuration),
			inp_presentation_delay: Math.round(e.attribution.presentationDelay)
		};
		case "CLS": return { debug_target: Z(e.attribution.largestShiftTarget) };
		default: return {};
	}
}, $ = (e) => {
	X.analytics.publish("web_vital", {
		metric_name: e.name,
		metric_value: e.name === "CLS" ? e.value : Math.round(e.value),
		metric_delta: e.name === "CLS" ? e.delta : Math.round(e.delta),
		metric_id: e.id,
		metric_rating: e.rating,
		navigation_type: e.navigationType,
		...Q(e)
	});
};
Y($), A($), K($), k($), V($);
//#endregion
